'use client';

import { c as _c } from "react/compiler-runtime";
import { useShallow } from 'zustand/react/shallow';
import { ADPOPCORN_LEGACY_BRIDGE_PLACEMENT_IDS, ADPOPCORN_OFFERWALL_MIN_APP_VERSION } from '@/constants/offerwall';
import { MESSAGE_KEYWORD, useHandleApp } from '@/modules/wello-app';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { isAppVersionAtLeast } from '@/utils';

//* 오퍼월 열기의 단일 진입점 — 앱 버전에 따라 브릿지·오퍼월 중 동작하는 경로를 고른다.
//* 3.1.21 미만은 오퍼월 핸들러가 없거나(3.1.15 이하, 무응답으로 아무 일도 안 일어난다)
//* setUserId를 부르지 않아 적립이 회원에 붙지 않는다. 버전 미확정(mount 전)도 브릿지로 보낸다 —
//* 브릿지는 애드팝콘을 지원하는 모든 버전에서 동작하므로 안전한 기본값이다.
export const useOpenAdpopcornOfferwall = () => {
  const $ = _c(10);
  const [osType, appVersion] = useDeviceInfoStore(useShallow(_temp));
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      type: MESSAGE_KEYWORD.OPEN_ADPOPCORN_OFFERWALL
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    request: requestOfferwall,
    isPending: isOfferwallPending
  } = useHandleApp(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: MESSAGE_KEYWORD.OPEN_ADPOPCORN_BRIDGE
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    request: requestBridge,
    isPending: isBridgePending
  } = useHandleApp(t1);
  let t2;
  if ($[2] !== appVersion || $[3] !== osType || $[4] !== requestBridge || $[5] !== requestOfferwall) {
    t2 = userId => {
      if (!!appVersion && isAppVersionAtLeast(appVersion, ADPOPCORN_OFFERWALL_MIN_APP_VERSION)) {
        requestOfferwall({
          userId
        });
        return;
      }
      requestBridge({
        placementId: ADPOPCORN_LEGACY_BRIDGE_PLACEMENT_IDS[osType === "ios" ? "ios" : "android"],
        userId
      });
    };
    $[2] = appVersion;
    $[3] = osType;
    $[4] = requestBridge;
    $[5] = requestOfferwall;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const open = t2;
  const t3 = isOfferwallPending || isBridgePending;
  let t4;
  if ($[7] !== open || $[8] !== t3) {
    t4 = {
      open,
      isOpening: t3
    };
    $[7] = open;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
function _temp(state) {
  return [state.osType, state.appVersion];
}